<template>
  <div class="pro-form-det">
    <!-- SETA O STATUS DA PAGINA -->
    <RF-Status v-if="statusGeral !== ''" :cpntStatus='statusGeral' :cpntIcone='false' :cpntTamanho='5'></RF-Status>
    
    <!-- MOSTRA A PAGINA -->
    <template v-else>
      <div>
        <App-Textarea :data-time="time" class="pro-form-det--obs"
          :cpntStatus='campos.obs.status'
          :cpntId='campos.obs.id'
          :cpntTabIndex='campos.obs.tabIndex'
          :cpntClassDivField='campos.obs.classDivField'
          :cpntNome='campos.obs.nome'
          :cpntValue='campos.obs.value'
          :cpntAutoComplete='campos.obs.autocomplete'
          :cpntMask='campos.obs.mask'
          :cpntOptionInicialNome='campos.obs.optionInicialNome'
          :cpntOptionInicialValue='campos.obs.optionInicialValue'
          :cpntDisabled='campos.obs.disabled'
          :cpntMostrar='campos.obs.mostrar'
          :cpntAutoFocus='campos.obs.autofocus'
          :cpntMensagem='campos.obs.mensagem'
          :cpntMensagemTipo='campos.obs.mensagemTipo'
          :cpntPlaceholder='campos.obs.placeholder'
          :cpntPosicionar='campos.obs.posicionar'
          :cpntOnChange='campos.obs.onChange'
          :cpntOnBlur='campos.obs.onBlur'
          ref='obs'
        ></App-Textarea>
      </div>

      <div>
        <App-Select :data-time="time" class="pro-form-det--pco_lista"
          :cpntStatus='campos.pco_lista.status'
          :cpntId='campos.pco_lista.id'
          :cpntTabIndex='campos.pco_lista.tabIndex'
          :cpntNome='campos.pco_lista.nome'
          :cpntValue='campos.pco_lista.value'
          :cpntMensagem='campos.pco_lista.mensagem'
          :cpntMensagemTipo='campos.pco_lista.mensagemTipo'
          :cpntDisabled='campos.pco_lista.disabled'
          :cpntMostrar='campos.pco_lista.mostrar'
          :cpntExplica='campos.pco_lista.explica'
          :cpntPlaceholder='campos.pco_lista.placeholder'
          :cpntValueRef='campos.pco_lista.valueRef'
          :cpntRouter='campos.pco_lista.router'
          :cpntMethod='campos.pco_lista.method'
          :cpntField='campos.pco_lista.field'
          :cpntWhere='campos.pco_lista.where'
          :cpntAddButForm='campos.pco_lista.addButForm'
          :cpntKeyMostra='campos.pco_lista.keyMostra'
          :cpntTipoOrder='campos.pco_lista.tipoOrder'
          :cpntOrder='campos.pco_lista.order'
          :cpntOptions='campos.pco_lista.options'
          :cpntKeyValue='campos.pco_lista.keyValue'
          :cpntSearchMinimo='campos.pco_lista.searchMinimo'
          :cpntMask='campos.pco_lista.mask'
          :cpntOptionInicialNome='campos.pco_lista.optionInicialNome'
          :cpntOptionInicialValue='campos.pco_lista.optionInicialValue'

          :cpntOnBuscarOptions='campos.pco_lista.onBuscarOptions'
          :cpntOnChange='campos.pco_lista.onChange'
          :cpntOnBlur='campos.pco_lista.onBlur'
          :cpntOnRealizaBusca='campos.pco_lista.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.pco_lista.onKeyPressEnter'
          ref="pco_lista"
        ></App-Select>

        <App-Input :data-time="time" class="pro-form-det--c_benef"
          :cpntStatus='campos.c_benef.status'
          :cpntId='campos.c_benef.id'
          :cpntTabIndex='campos.c_benef.tabIndex'
          :cpntClassDivField='campos.c_benef.classDivField'
          :cpntNome='campos.c_benef.nome'
          :cpntValue='campos.c_benef.value'
          :cpntAutoComplete='campos.c_benef.autocomplete'
          :cpntMask='campos.c_benef.mask'
          :cpntOptionInicialNome='campos.c_benef.optionInicialNome'
          :cpntOptionInicialValue='campos.c_benef.optionInicialValue'
          :cpntDisabled='campos.c_benef.disabled'
          :cpntMostrar='campos.c_benef.mostrar'
          :cpntExplica='campos.c_benef.explica'
          :cpntAutoFocus='campos.c_benef.autofocus'
          :cpntMensagem='campos.c_benef.mensagem'
          :cpntMensagemTipo='campos.c_benef.mensagemTipo'
          :cpntPlaceholder='campos.c_benef.placeholder'
          :cpntPosicionar='campos.c_benef.posicionar'
          :cpntOnChange='campos.c_benef.onChange'
          :cpntOnBlur='campos.c_benef.onBlur'
          ref='c_benef'
        ></App-Input>
      </div>

      <div>
        <App-Input :data-time="time" class="pro-form-det--cod_fornecedor"
          :cpntStatus='campos.cod_fornecedor.status'
          :cpntId='campos.cod_fornecedor.id'
          :cpntTabIndex='campos.cod_fornecedor.tabIndex'
          :cpntClassDivField='campos.cod_fornecedor.classDivField'
          :cpntNome='campos.cod_fornecedor.nome'
          :cpntValue='campos.cod_fornecedor.value'
          :cpntAutoComplete='campos.cod_fornecedor.autocomplete'
          :cpntMask='campos.cod_fornecedor.mask'
          :cpntOptionInicialNome='campos.cod_fornecedor.optionInicialNome'
          :cpntOptionInicialValue='campos.cod_fornecedor.optionInicialValue'
          :cpntDisabled='campos.cod_fornecedor.disabled'
          :cpntMostrar='campos.cod_fornecedor.mostrar'
          :cpntExplica='campos.cod_fornecedor.explica'
          :cpntAutoFocus='campos.cod_fornecedor.autofocus'
          :cpntMensagem='campos.cod_fornecedor.mensagem'
          :cpntMensagemTipo='campos.cod_fornecedor.mensagemTipo'
          :cpntPlaceholder='campos.cod_fornecedor.placeholder'
          :cpntPosicionar='campos.cod_fornecedor.posicionar'
          :cpntOnChange='campos.cod_fornecedor.onChange'
          :cpntOnBlur='campos.cod_fornecedor.onBlur'
          ref='cod_fornecedor'
        ></App-Input>
      </div>

      <div>
        <App-Select :data-time="time" class="pro-form-det--ind_escala"
          :cpntStatus='campos.ind_escala.status'
          :cpntId='campos.ind_escala.id'
          :cpntTabIndex='campos.ind_escala.tabIndex'
          :cpntNome='campos.ind_escala.nome'
          :cpntValue='campos.ind_escala.value'
          :cpntMensagem='campos.ind_escala.mensagem'
          :cpntMensagemTipo='campos.ind_escala.mensagemTipo'
          :cpntDisabled='campos.ind_escala.disabled'
          :cpntMostrar='campos.ind_escala.mostrar'
          :cpntExplica='campos.ind_escala.explica'
          :cpntPlaceholder='campos.ind_escala.placeholder'
          :cpntValueRef='campos.ind_escala.valueRef'
          :cpntRouter='campos.ind_escala.router'
          :cpntMethod='campos.ind_escala.method'
          :cpntField='campos.ind_escala.field'
          :cpntWhere='campos.ind_escala.where'
          :cpntAddButForm='campos.ind_escala.addButForm'
          :cpntKeyMostra='campos.ind_escala.keyMostra'
          :cpntTipoOrder='campos.ind_escala.tipoOrder'
          :cpntOrder='campos.ind_escala.order'
          :cpntOptions='campos.ind_escala.options'
          :cpntKeyValue='campos.ind_escala.keyValue'
          :cpntSearchMinimo='campos.ind_escala.searchMinimo'
          :cpntMask='campos.ind_escala.mask'
          :cpntOptionInicialNome='campos.ind_escala.optionInicialNome'
          :cpntOptionInicialValue='campos.ind_escala.optionInicialValue'

          :cpntOnBuscarOptions='campos.ind_escala.onBuscarOptions'
          :cpntOnChange='campos.ind_escala.onChange'
          :cpntOnBlur='campos.ind_escala.onBlur'
          :cpntOnRealizaBusca='campos.ind_escala.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.ind_escala.onKeyPressEnter'
          ref="ind_escala"
        ></App-Select>

        <App-Input :data-time="time" class="pro-form-det--cnpj_fab" v-if="campos.ind_escala.value === 'N' || campos.ind_escala.value.id === 'N'"
          :cpntStatus='campos.cnpj_fab.status'
          :cpntId='campos.cnpj_fab.id'
          :cpntTabIndex='campos.cnpj_fab.tabIndex'
          :cpntClassDivField='campos.cnpj_fab.classDivField'
          :cpntNome='campos.cnpj_fab.nome'
          :cpntValue='campos.cnpj_fab.value'
          :cpntAutoComplete='campos.cnpj_fab.autocomplete'
          :cpntMask='campos.cnpj_fab.mask'
          :cpntOptionInicialNome='campos.cnpj_fab.optionInicialNome'
          :cpntOptionInicialValue='campos.cnpj_fab.optionInicialValue'
          :cpntDisabled='campos.cnpj_fab.disabled'
          :cpntMostrar='campos.cnpj_fab.mostrar'
          :cpntExplica='campos.cnpj_fab.explica'
          :cpntAutoFocus='campos.cnpj_fab.autofocus'
          :cpntMensagem='campos.cnpj_fab.mensagem'
          :cpntMensagemTipo='campos.cnpj_fab.mensagemTipo'
          :cpntPlaceholder='campos.cnpj_fab.placeholder'
          :cpntPosicionar='campos.cnpj_fab.posicionar'
          :cpntOnChange='campos.cnpj_fab.onChange'
          :cpntOnBlur='campos.cnpj_fab.onBlur'
          ref='cnpj_fab'
        ></App-Input>
      </div>

      <div>
        <App-Select :data-time="time" class="pro-form-det--id_tp_item"
          :cpntStatus='campos.id_tp_item.status'
          :cpntId='campos.id_tp_item.id'
          :cpntTabIndex='campos.id_tp_item.tabIndex'
          :cpntNome='campos.id_tp_item.nome'
          :cpntValue='campos.id_tp_item.value'
          :cpntMensagem='campos.id_tp_item.mensagem'
          :cpntMensagemTipo='campos.id_tp_item.mensagemTipo'
          :cpntDisabled='campos.id_tp_item.disabled'
          :cpntMostrar='campos.id_tp_item.mostrar'
          :cpntExplica='campos.id_tp_item.explica'
          :cpntPlaceholder='campos.id_tp_item.placeholder'
          :cpntValueRef='campos.id_tp_item.valueRef'
          :cpntRouter='campos.id_tp_item.router'
          :cpntMethod='campos.id_tp_item.method'
          :cpntField='campos.id_tp_item.field'
          :cpntWhere='campos.id_tp_item.where'
          :cpntAddButForm='campos.id_tp_item.addButForm'
          :cpntKeyMostra='campos.id_tp_item.keyMostra'
          :cpntTipoOrder='campos.id_tp_item.tipoOrder'
          :cpntOrder='campos.id_tp_item.order'
          :cpntOptions='campos.id_tp_item.options'
          :cpntKeyValue='campos.id_tp_item.keyValue'
          :cpntSearchMinimo='campos.id_tp_item.searchMinimo'
          :cpntMask='campos.id_tp_item.mask'
          :cpntOptionInicialNome='campos.id_tp_item.optionInicialNome'
          :cpntOptionInicialValue='campos.id_tp_item.optionInicialValue'

          :cpntOnBuscarOptions='campos.id_tp_item.onBuscarOptions'
          :cpntOnChange='campos.id_tp_item.onChange'
          :cpntOnBlur='campos.id_tp_item.onBlur'
          :cpntOnRealizaBusca='campos.id_tp_item.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.id_tp_item.onKeyPressEnter'
          ref="id_tp_item"
        ></App-Select>

        <template v-if="campos.id_tp_item.value === '4' || campos.id_tp_item.value.id === '4'">
          <App-Input :data-time="time" class="pro-form-det--anp_cod"
            :cpntStatus='campos.anp_cod.status'
            :cpntId='campos.anp_cod.id'
            :cpntTabIndex='campos.anp_cod.tabIndex'
            :cpntClassDivField='campos.anp_cod.classDivField'
            :cpntNome='campos.anp_cod.nome'
            :cpntValue='campos.anp_cod.value'
            :cpntAutoComplete='campos.anp_cod.autocomplete'
            :cpntMask='campos.anp_cod.mask'
            :cpntOptionInicialNome='campos.anp_cod.optionInicialNome'
            :cpntOptionInicialValue='campos.anp_cod.optionInicialValue'
            :cpntDisabled='campos.anp_cod.disabled'
            :cpntMostrar='campos.anp_cod.mostrar'
            :cpntExplica='campos.anp_cod.explica'
            :cpntAutoFocus='campos.anp_cod.autofocus'
            :cpntMensagem='campos.anp_cod.mensagem'
            :cpntMensagemTipo='campos.anp_cod.mensagemTipo'
            :cpntPlaceholder='campos.anp_cod.placeholder'
            :cpntPosicionar='campos.anp_cod.posicionar'
            :cpntOnChange='campos.anp_cod.onChange'
            :cpntOnBlur='campos.anp_cod.onBlur'
            ref='anp_cod'
          ></App-Input>

          <App-Input :data-time="time" class="pro-form-det--anp_desc"
            :cpntStatus='campos.anp_desc.status'
            :cpntId='campos.anp_desc.id'
            :cpntTabIndex='campos.anp_desc.tabIndex'
            :cpntClassDivField='campos.anp_desc.classDivField'
            :cpntNome='campos.anp_desc.nome'
            :cpntValue='campos.anp_desc.value'
            :cpntAutoComplete='campos.anp_desc.autocomplete'
            :cpntMask='campos.anp_desc.mask'
            :cpntOptionInicialNome='campos.anp_desc.optionInicialNome'
            :cpntOptionInicialValue='campos.anp_desc.optionInicialValue'
            :cpntDisabled='campos.anp_desc.disabled'
            :cpntMostrar='campos.anp_desc.mostrar'
            :cpntExplica='campos.anp_desc.explica'
            :cpntAutoFocus='campos.anp_desc.autofocus'
            :cpntMensagem='campos.anp_desc.mensagem'
            :cpntMensagemTipo='campos.anp_desc.mensagemTipo'
            :cpntPlaceholder='campos.anp_desc.placeholder'
            :cpntPosicionar='campos.anp_desc.posicionar'
            :cpntOnChange='campos.anp_desc.onChange'
            :cpntOnBlur='campos.anp_desc.onBlur'
            ref='anp_desc'
          ></App-Input>
        </template>
      </div>

      <div v-if="(campos.id_tp_item.value === '4' || campos.id_tp_item.value.id === '4') && campos.anp_cod.value === '210203001'">
        <App-Input :data-time="time" class="pro-form-det--glp_p_glp"
          :cpntStatus='campos.glp_p_glp.status'
          :cpntId='campos.glp_p_glp.id'
          :cpntTabIndex='campos.glp_p_glp.tabIndex'
          :cpntClassDivField='campos.glp_p_glp.classDivField'
          :cpntNome='campos.glp_p_glp.nome'
          :cpntValue='campos.glp_p_glp.value'
          :cpntAutoComplete='campos.glp_p_glp.autocomplete'
          :cpntMask='campos.glp_p_glp.mask'
          :cpntOptionInicialNome='campos.glp_p_glp.optionInicialNome'
          :cpntOptionInicialValue='campos.glp_p_glp.optionInicialValue'
          :cpntDisabled='campos.glp_p_glp.disabled'
          :cpntMostrar='campos.glp_p_glp.mostrar'
          :cpntExplica='campos.glp_p_glp.explica'
          :cpntAutoFocus='campos.glp_p_glp.autofocus'
          :cpntMensagem='campos.glp_p_glp.mensagem'
          :cpntMensagemTipo='campos.glp_p_glp.mensagemTipo'
          :cpntPlaceholder='campos.glp_p_glp.placeholder'
          :cpntPosicionar='campos.glp_p_glp.posicionar'
          :cpntOnChange='campos.glp_p_glp.onChange'
          :cpntOnBlur='campos.glp_p_glp.onBlur'
          ref='glp_p_glp'
        ></App-Input>

        <App-Input :data-time="time" class="pro-form-det--glp_p_gnn"
          :cpntStatus='campos.glp_p_gnn.status'
          :cpntId='campos.glp_p_gnn.id'
          :cpntTabIndex='campos.glp_p_gnn.tabIndex'
          :cpntClassDivField='campos.glp_p_gnn.classDivField'
          :cpntNome='campos.glp_p_gnn.nome'
          :cpntValue='campos.glp_p_gnn.value'
          :cpntAutoComplete='campos.glp_p_gnn.autocomplete'
          :cpntMask='campos.glp_p_gnn.mask'
          :cpntOptionInicialNome='campos.glp_p_gnn.optionInicialNome'
          :cpntOptionInicialValue='campos.glp_p_gnn.optionInicialValue'
          :cpntDisabled='campos.glp_p_gnn.disabled'
          :cpntMostrar='campos.glp_p_gnn.mostrar'
          :cpntExplica='campos.glp_p_gnn.explica'
          :cpntAutoFocus='campos.glp_p_gnn.autofocus'
          :cpntMensagem='campos.glp_p_gnn.mensagem'
          :cpntMensagemTipo='campos.glp_p_gnn.mensagemTipo'
          :cpntPlaceholder='campos.glp_p_gnn.placeholder'
          :cpntPosicionar='campos.glp_p_gnn.posicionar'
          :cpntOnChange='campos.glp_p_gnn.onChange'
          :cpntOnBlur='campos.glp_p_gnn.onBlur'
          ref='glp_p_gnn'
        ></App-Input> 

        <App-Input :data-time="time" class="pro-form-det--glp_p_gni"
          :cpntStatus='campos.glp_p_gni.status'
          :cpntId='campos.glp_p_gni.id'
          :cpntTabIndex='campos.glp_p_gni.tabIndex'
          :cpntClassDivField='campos.glp_p_gni.classDivField'
          :cpntNome='campos.glp_p_gni.nome'
          :cpntValue='campos.glp_p_gni.value'
          :cpntAutoComplete='campos.glp_p_gni.autocomplete'
          :cpntMask='campos.glp_p_gni.mask'
          :cpntOptionInicialNome='campos.glp_p_gni.optionInicialNome'
          :cpntOptionInicialValue='campos.glp_p_gni.optionInicialValue'
          :cpntDisabled='campos.glp_p_gni.disabled'
          :cpntMostrar='campos.glp_p_gni.mostrar'
          :cpntExplica='campos.glp_p_gni.explica'
          :cpntAutoFocus='campos.glp_p_gni.autofocus'
          :cpntMensagem='campos.glp_p_gni.mensagem'
          :cpntMensagemTipo='campos.glp_p_gni.mensagemTipo'
          :cpntPlaceholder='campos.glp_p_gni.placeholder'
          :cpntPosicionar='campos.glp_p_gni.posicionar'
          :cpntOnChange='campos.glp_p_gni.onChange'
          :cpntOnBlur='campos.glp_p_gni.onBlur'
          ref='glp_p_gni'
        ></App-Input>

        <App-Input :data-time="time" class="pro-form-det--glp_v_par"
          :cpntStatus='campos.glp_v_par.status'
          :cpntId='campos.glp_v_par.id'
          :cpntTabIndex='campos.glp_v_par.tabIndex'
          :cpntClassDivField='campos.glp_v_par.classDivField'
          :cpntNome='campos.glp_v_par.nome'
          :cpntValue='campos.glp_v_par.value'
          :cpntAutoComplete='campos.glp_v_par.autocomplete'
          :cpntMask='campos.glp_v_par.mask'
          :cpntOptionInicialNome='campos.glp_v_par.optionInicialNome'
          :cpntOptionInicialValue='campos.glp_v_par.optionInicialValue'
          :cpntDisabled='campos.glp_v_par.disabled'
          :cpntMostrar='campos.glp_v_par.mostrar'
          :cpntExplica='campos.glp_v_par.explica'
          :cpntAutoFocus='campos.glp_v_par.autofocus'
          :cpntMensagem='campos.glp_v_par.mensagem'
          :cpntMensagemTipo='campos.glp_v_par.mensagemTipo'
          :cpntPlaceholder='campos.glp_v_par.placeholder'
          :cpntPosicionar='campos.glp_v_par.posicionar'
          :cpntOnChange='campos.glp_v_par.onChange'
          :cpntOnBlur='campos.glp_v_par.onBlur'
          ref='glp_v_par'
        ></App-Input>
      </div>
    </template>
  </div>
</template>

<style scoped>
.pro-form-det {
  width: 100%;
  padding-top: 15px;
  text-align: left;
}
  .pro-form-det > div:not(:first-child) {
    padding-top: 22px;
  }
  .pro-form-det > div,
  .pro-form-det > div > div {
    width: 100%;
  }
    .pro-form-det > div > .pro-form-det--cod_fornecedor,
    .pro-form-det > div > .pro-form-det--pco_lista,
    .pro-form-det > div > .pro-form-det--c_benef,
    .pro-form-det > div > .pro-form-det--ind_escala,
    .pro-form-det > div > .pro-form-det--cnpj_fab,
    .pro-form-det > div > .pro-form-det--id_tp_item {
      width: calc(50% - 5px);
    }
    .pro-form-det > div > .pro-form-det--anp_cod,
    .pro-form-det > div > .pro-form-det--anp_desc {
      width: calc(25% - (15px / 2));
    }

    .pro-form-det > div > .pro-form-det--glp_p_glp,
    .pro-form-det > div > .pro-form-det--glp_p_gnn,
    .pro-form-det > div > .pro-form-det--glp_p_gni,
    .pro-form-det > div > .pro-form-det--glp_v_par {
      width: calc(25% - (30px / 4));
    }
    .pro-form-det > div > .pro-form-det--pco_lista {
      margin-right: 10px;
    }
    .pro-form-det > div > .pro-form-det--anp_cod,
    .pro-form-det > div > .pro-form-det--anp_desc,
    .pro-form-det > div > .pro-form-det--cnpj_fab,
    .pro-form-det > div > .pro-form-det--glp_p_gnn,
    .pro-form-det > div > .pro-form-det--glp_p_gni,
    .pro-form-det > div > .pro-form-det--glp_v_par {
      margin-left: 10px;
    }
</style>

<style>
</style>

<script>
export default {
  props: {
    cpntHashId: {
      required: true
    },
    cpntId: {
      required: true
    },
    cpntEditarVarios: {
      required: true
    },
    cpntDados: {
      required: false,
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {
      time: '',
      statusGeral: 'carregando',
      campos: {
        obs: {
          id: this.cpntHashId + '--obs',
          status: '',
          tabIndex: 6002001,
          nome: 'Observação',
          value: '',
          valueIni: '',
          apiEnv: 'obs',
          onChange: this.proFormDetalheOnChangeValue
        },
        pco_lista: {
          id: this.cpntHashId + '--pco_lista',
          status: '',
          tabIndex: 6002002,
          nome: 'Controle de processos',
          keyValue: 'id',
          keyMostra: [ 'nome' ],
          options: [],
          apiEnv: 'id_pco_status',
          mostrar: true,
          optionInicialNome: '',
          optionInicialValue: '-1',
          value: '',
          valueIni: '',
          explica: { mensagem: 'Selecione a lista de processo que deve ser utilizada para este produto.' },
          onBuscarOptions: this.proFormDetalheBuscarListaControleProcesso,
          onChange: this.proFormDetalheOnChangeValue
        },
        c_benef: {
          id: this.cpntHashId + '--c_benef',
          status: '',
          tabIndex: 6002003,
          nome: 'Código de Benefício Fiscal',
          value: '',
          valueIni: '',
          apiEnv: 'c_benef',
          explica: { mensagem: 'O que é benefício fiscal?<br/>Um benefício fiscal é um regime especial de tributação, que é criado e desenvolvido pela administração pública com o intuito de fomentar o crescimento de algum setor, atividade econômica ou região em particular, oferecendo vantagens (incentivos fiscais).<br/><br/>O governo pode conceder benefícios de diversas maneiras, entre elas:<br/><br/>Imunidade;<br/>Isenção de tributos;<br/>Compensação de tributos;<br/><br/>Ao ser beneficiada por algum desses programas, surge a necessidade de informar na NF-e ou NFC-e qual o benefício adquirido.<br/><br/>Então esse é o Código de Benefício (cBenef), um campo de preenchimento criado para resolver essa questão.<br/><br/>Como funciona o campo cBenef?<br/>O código cBenef é formado por uma sequência alfanumérica de 8 dígitos, devendo ser preenchido com a seguinte estrutura:<br/><br/>Código com 8 dígitos = UF B C DDDD, sendo:<br/><br/>UF = Unidade da Federação<br/><br/>B = Finalidade<br/><br/>C = Benefício<br/><br/>DDDD = Sequência Numérica<br/>' },
          onChange: this.proFormDetalheOnChangeValue
        },
        cod_fornecedor: {
          id: this.cpntHashId + '--cod_fornecedor',
          status: '',
          tabIndex: 6002003,
          nome: 'Código do Fornecedor',
          value: '',
          valueIni: '',
          apiEnv: 'cod_fornecedor',
          explica: { mensagem: 'Informe aqui o código usado pelo seu fornecedor.' },
          onChange: this.proFormDetalheOnChangeValue
        },
        ind_escala: {
          id: this.cpntHashId + '--ind_escala',
          status: '',
          tabIndex: 6002004,
          nome: 'Indicador de escala relevante',
          keyValue: 'id',
          keyMostra: [ 'nome' ],
          options: [
            { id: 'S', nome: 'Produzido em Escala Relevante' },
            { id: 'N', nome: 'Produzido em Escala NÃO Relevante' }
          ],
          value: '',
          valueIni: '',
          optionInicialNome: 'Selecione',
          apiEnv: 'ind_escala',
          explica: { mensagem: 'Indicador de Produção em escala relevante, conforme Cláusula 23 do Convênio ICMS 52/2017:<br/><br/>S - Produzido em Escala Relevante;<br/>N - Produzido em Escala NÃO Relevante.<br/><br/>Nota: preenchimento obrigatório para produtos com NCM relacionado no Anexo XXVII do Convenio 52/2017.' },
          onChange: this.proFormDetalheOnChangeValue
        },
        cnpj_fab: {
          id: this.cpntHashId + '--cnpj_fab',
          status: '',
          tabIndex: 6002005,
          nome: 'CNPJ do Fabricante da Mercadoria',
          value: '',
          valueIni: '',
          apiEnv: 'cnpj_fab',
          mask: 'cnpj',
          explica: { mensagem: 'CNPJ do Fabricante da Mercadoria, obrigatório para produto em escala NÃO relevante.' },
          onChange: this.proFormDetalheOnChangeValue
        },
        id_tp_item: {
          id: this.cpntHashId + '--id_tp_item',
          status: '',
          tabIndex: 6002006,
          nome: 'Tipo',
          keyValue: 'id',
          keyMostra: [ 'id', ' - ', 'nome' ],
          options: [],
          apiEnv: 'id_tp_item',
          mostrar: true,
          optionInicialNome: 'Selecione',
          value: '',
          valueIni: '',
          onBuscarOptions: this.proFormDetalheBuscarTipo,
          onChange: this.proFormDetalheOnChangeValue
        },
        anp_cod: {
          id: this.cpntHashId + '--anp_cod',
          status: '',
          tabIndex: 6002007,
          nome: 'Cód. ANP',
          value: '',
          valueIni: '',
          apiEnv: 'anp_cod',
          onChange: this.proFormDetalheOnChangeValue
        },
        anp_desc: {
          id: this.cpntHashId + '--anp_desc',
          status: '',
          tabIndex: 6002008,
          nome: 'Descrição ANP',
          value: '',
          valueIni: '',
          apiEnv: 'anp_desc',
          explica: { mensagem: 'Descrição do produto conforme ANP' },
          onChange: this.proFormDetalheOnChangeValue
        },
        glp_p_glp: {
          id: this.cpntHashId + '--glp_p_glp',
          status: '',
          tabIndex: 6002009,
          nome: '% GLP D P',
          value: '',
          valueIni: '',
          mask: 'VALOR_DECIMAL_CAMPO',
          apiEnv: 'glp_p_glp',
          explica: { mensagem: 'Percentual do GLP derivado do petróleo no produto GLP' },
          onChange: this.proFormDetalheOnChangeValue
        },
        glp_p_gnn: {
          id: this.cpntHashId + '--glp_p_gnn',
          status: '',
          tabIndex: 6002010,
          nome: '% GNN',
          value: '',
          valueIni: '',
          mask: 'VALOR_DECIMAL_CAMPO',
          apiEnv: 'glp_p_gnn',
          explica: { mensagem: 'Percentual de Gás Natural Nacional para o produto GLP' },
          onChange: this.proFormDetalheOnChangeValue
        },
        glp_p_gni: {
          id: this.cpntHashId + '--glp_p_gni',
          status: '',
          tabIndex: 6002011,
          nome: '% GNI',
          value: '',
          valueIni: '',
          mask: 'VALOR_DECIMAL_CAMPO',
          apiEnv: 'glp_p_gni',
          explica: { mensagem: 'Percentual de Gás Natural Importado - GLGNi para o produto GLP' },
          onChange: this.proFormDetalheOnChangeValue
        },
        glp_v_par: {
          id: this.cpntHashId + '--glp_v_par',
          status: '',
          tabIndex: 60020012,
          nome: 'Valor de partida',
          value: '',
          valueIni: '',
          mask: 'valorMoeda',
          apiEnv: 'glp_v_par',
          explica: { mensagem: 'Deve ser informado neste campo o valor por quilograma sem ICMS.' },
          onChange: this.proFormDetalheOnChangeValue
        },
      }
    }
  },
  mounted: function () {
    this.proFormDetalheIniciar()
  },
  methods: {
    proFormDetalheCarregarPadraoControleProcesso: function (callback) {
      if (this.cpntEditarVarios === false && this.$store.state.pcoAntigo === false && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 11 ], null, null, null, null, null, false) === true) {
        // SETA O NOME DA CHAVE QUE DEVE ENVIAR PARA API
        this.campos.pco_lista.apiEnv = 'id_pco_status'

        // SETA QUE DEVE MOSTRAR O CAMPO
        this.campos.pco_lista.mostrar = true

        // SETA O VALOR INICIAL DO CAMPO
        if ([ '', null, undefined ].indexOf(this.$store.state.configuracoes.produto.est.cfg_id_pco_status) === -1) {
          this.proFormDetalheBuscarListaControleProcesso(() => {
            // PEGA O OPTION RECEBIDO
            var option = this.campos.pco_lista.options.filter(item => item.id === this.$store.state.configuracoes.produto.est.cfg_id_pco_status)

            // VERIFICA SE FOI ENCONTRADO ALGUM VALOR
            option = option.length >= 1 ? option[0] : ''

            // SETA O VALOR RECEBIDO
            this.campos.pco_lista.value = option

            // EXECUTA O CALLBACK RECEBIDO
            callback()
          })
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    proFormDetalheIniciar: function () {
      // SETA O STATUS DA PAGINA
      this.proFormDetalheSetaStatusGeral('carregando')

      // CARREGA O CONTROLE DE PROCESSOS PADRÃO DO FORMULARIO
      this.proFormDetalheCarregarPadraoControleProcesso(() => {
        // VERIFICA SE ESTÁ EDITANDO UM PRODUTO
        if (typeof this.cpntId !== 'object' && this.cpntId >= 1) {
          // PEGA O NOME DE CADA CHAVE QUE DEVE SETAR O VALOR
          var chaves = Object.keys(this.campos)
  
          // RODA O VETOR DOS CAMPOS
          for (var indexC in chaves) {
            // SETA O NOME DA CHAVE QUE SERÁ TRABALHADA
            var chave = chaves[indexC]
  
            // SETA OS VALORES DO CAMPO
            this.proFormDetalheSetarValorCampo(chave, this.cpntDados)
  
            // SETA O VALOR INICIAL DO CAMPO
            this.campos[chave].valueIni = this.campos[chave].value
          }
  
          // SETA O STATUS DA PAGINA
          this.proFormDetalheSetaStatusGeral('')
        } else {
          this.proFormDetalheSetaStatusGeral('')
        }
      })

      //Verifica se deve apresentar o campo Codigo Fornecedor
      this.campos.cod_fornecedor.mostrar = !this.cpntEditarVarios
    },
    proFormDetalheSetaStatusGeral: function (status) {
      // SETA O STATUS DA TELA
      this.statusGeral = status

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    proFormDetalheSetarValorCampo: function (chave, dados) {
      // INICIA A VARIAVEL DE VALOR
      var value = ''
      var valueRef = ''
      var options = null

      // VERIFICA O VALOR QUE DEVE SELECIONAR
      switch (chave) {
        case 'obs':
        case 'cod_fornecedor':
        case 'c_benef':
        case 'ind_escala':
        case 'cnpj_fab':
        case 'anp_cod':
        case 'anp_desc':
        case 'glp_p_glp':
        case 'glp_p_gnn':
        case 'glp_p_gni':
        case 'glp_v_par':
          value = [ '', null, undefined ].indexOf(dados[chave]) === -1 ? dados[chave] : ''
          break

        case 'pco_lista':
          value = { id: dados.id_pco_status, nome: dados.id_pco_status_nome }
          break

        case 'id_tp_item':
          value = { id: dados.id_tp_item, nome: dados.virtual_id_tp_item_desc }
          break
      }

      // PEGA OS OPTIONS DO CAMPO
      if (options === null && [ '', null, undefined ].indexOf(this.campos[chave].options) === -1 && this.campos[chave].options.length >= 1) {
        options = this.campos[chave].options
      }

      // VERIFICA SE TEM OPTION E O VALOR SELECIONADO É UM STRING
      if (options !== null && options.length >= 1 && typeof value === 'string') {
        // PEGA O VALOR DO CAMPO
        var valor = options.filter((option) => { return option[this.campos[chave].keyValue] === value })

        // SETA O VALOR ENCONTRADO
        value = valor.length === 1 ? valor[0] : value
      }

      // SETA O VALOR ATUALIZADO DO CAMPO
      this.$set(this.campos[chave], 'value', value)
      this.$set(this.campos[chave], 'valueRef', valueRef)

      // VERIFICA SE TEM VALOR PARA ATUALIZAR
      if (options !== null) {
        this.$set(this.campos[chave], 'options', options)
      }

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    proFormDetalheOnChangeValue: function (value, id) {
      // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
      var indexF = id.split('--')

      // SETA O VALOR RECEBIDO
      this.$set(this.campos[indexF[1]], 'value', value)

      // LIMPA O CAMPO DE MENSAGEM DE ERRO
      this.$set(this.campos[indexF[1]], 'mensagem', '')

      // MANDA REMOVER A MENSAGEM DE ERRO DA ABA
      this.$emit('PRODUTO_FORMULARIO_REMOVER_ERRO', id)

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    proFormDetalheBuscarListaControleProcesso: function (callback, id, total = null, registros = []) {
      if (total === null || total < registros.length) {
        // MONTA O QUERY GET
        var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

        // SETA OS CAMPOS QUE DEVEJA 
        queryGet.field = { id: null, nome: null }

        // SETA O WHERE QUE DEVE REALIZAR
        queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }

        // FAZ A BUSCA DOS DADOS
        this.$store.state.comunicaAPI('/con-processo/config/status/get/', 'GET', queryGet, (apiSuccess) => {
          // JUNTA OS VALORES RECEBIDOS
          registros = registros.concat(apiSuccess.data)

          // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
          this.proFormDetalheBuscarListaControleProcesso(callback, id, Number(apiSuccess.countAll), registros)
        }, (apiError) => {
          // SETA OS VALORES RECEBIDOS
          this.campos.pco_lista.status = apiError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        })
      } else if (total === 0) {
        // SETA OS VALORES RECEBIDOS
        this.campos.pco_lista.onBuscarOptions = null

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // EXECUTA A FUNÇÃO CALLBACK
        callback()
      } else {
        // SETA A OPÇÃO PADRÃO
        registros.unshift({ id: '', nome: 'Sem padrão' })

        // SETA OS VALORES RECEBIDOS
        this.campos.pco_lista.options = registros

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // EXECUTA A FUNÇÃO CALLBACK
        callback()
      }
    },
    proFormDetalheBuscarTipo: function (callback) {
      this.$store.state.comunicaAPI('/produto/tipo/get', 'GET', null, (registros) => {
        // SETA OS VALORES RECEBIDOS
        this.campos.id_tp_item.options = registros.data

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // EXECUTA A FUNÇÃO CALLBACK
        callback()
      }, (apiError) => {
        // SETA OS VALORES RECEBIDOS
        this.campos.id_tp_item.options = apiError

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      })
    }
  }
}
</script>
